import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-profile-page',
  standalone: false,
  templateUrl: './profile-page.html',
})
export class ProfilePage {
  suiteUrl = environment.suiteUrl;
}
